import koDict from "./dictionaries/ko.json";
import enDict from "./dictionaries/en.json";

export type Lang = "ko" | "en";
export type Dictionary = typeof koDict;

const dictionaries: Record<Lang, Dictionary> = {
  ko: koDict,
  en: enDict,
};

export function getDictionary(lang: Lang): Dictionary {
  return dictionaries[lang] || dictionaries.ko;
}
